import { connect } from 'react-redux'
import SharedTable from './shared-table'
import { getPresentationsList } from '../../../../../../stores/shared-presentations/shared-presentations.selectors'

const mapStateToProps = state => ({
  presentations: getPresentationsList(state)
})

export default connect(
  mapStateToProps,
  null
)(SharedTable)
